module.exports = __webpack_public_path__ + "img/Daucus_carota.d1ad8ea4.jpg";